import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
    position: relative;
`;

export const BoxTextPackTracking = styled.p`
  margin: 0 0 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const BoxGridParts = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  
  p {
    margin: 0;
  }
  `;
